import { PreFillData } from './merchantApplicationModel'

// TODO: Replace with real endpoints using the shared axios instance from '../api'
// e.g. import api from '../../components/api'
//      const { data } = await api.get<PreFillData>('/merchant-application/pre-fill')

const SIMULATED_DELAY = 600

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

/**
 * Fetches pre-fill data for the merchant application.
 * In production, this will call a dedicated endpoint that merges
 * user profile, tenant, tenant location, and payment history data.
 */
export const getMerchantApplicationPreFill = async (): Promise<PreFillData> => {
  await delay(SIMULATED_DELAY)

  return {
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'owner@example.com',
    businessName: 'Acme Landscaping LLC',
    phoneNumber: '(555) 555-0100',
    website: 'www.example.com',
    address1: '123 Main St',
    city: 'Springfield',
    stateCode: 'OH',
    zip: '43215',
    paymentEstimates: {
      averagePayment: 285,
      maximumPayment: 8500,
      monthlyTotal: 24000,
    },
  }
}

export type SubmitMerchantApplicationRequest = {
  confirmInfo: {
    firstName: string
    lastName: string
    email: string
    businessName: string
    businessDba: string
    phoneNumber: string
    website: string
    address1: string
    city: string
    stateCode: string
    zip: string
  }
  businessDetails: {
    taxId: string
    organizationType: string
    averagePaymentAmount: number
    maximumPaymentAmount: number
    monthlyPaymentTotal: number
  }
  owners: {
    firstName: string
    lastName: string
    email: string
    phone: string
    dateOfBirth: string
    ssn: string
    ownershipPercentage: number
    address1: string
    city: string
    stateCode: string
    zip: string
  }[]
  bankAccount: {
    bankName: string
    routingNumber: string
    accountNumber: string
  }
  documents: {
    taxIdDocument?: File
    identificationDocument?: File
    bankDocument?: File
  }
}

/**
 * Submits the completed merchant application.
 * In production, this will POST to the backend which forwards to Rainforest.
 */
export const submitMerchantApplication = async (_request: SubmitMerchantApplicationRequest): Promise<void> => {
  // TODO: Replace with real POST to backend
  throw new Error('Merchant application backend not yet implemented')
}
